import * as CONST from "./constant";

export class GptVersions {
    static readonly GPTMODEL_DEFAULT = CONST.AI_MODEL_NAME.GPTMODEL_DEFAULT;
    static readonly GPTMODEL_CHANGE = CONST.AI_MODEL_NAME.GPTMODEL_CHANGE;

    static convertToDisplayString(version: string): string {
        switch (version) {
            case CONST.AI_MODEL_VALUE.GPTMODEL_DEFAULT:
                return GptVersions.GPTMODEL_DEFAULT;
            case CONST.AI_MODEL_VALUE.GPTMODEL_CHANGE:
                return GptVersions.GPTMODEL_CHANGE;
            default:
                return version;
        }
    }
}
